import React, { useState, useEffect } from 'react';
import { getSource } from 'utils/api';
import moment from 'moment';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { numberWithCommas, getInfluenceName } from 'utils/other';
import { toast } from 'react-toastify';
import {textTruncateByLength} from 'utils/other';
//import './style.scss';

const ItemsOnPageAfterPagination = 50;
const paginationButtonsCount = 5;
const paginationButtonsBoundary = 2;

const FeedPreviewModal = ({ isOpen, toggle, source }) => {
    const [feedSource, setFeed] = useState(null);
    const [showBtn, setMode] = useState(false);
    const [activePage, changePagination] = useState(1);
    
    useEffect(() => {
        getSourceNews();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getSourceNews = async () => {
        try {
            let sourceNews = await getSource(source.id);
            sourceNews = [...sourceNews.content.result];

            sourceNews.sort((a, b) => {
                if (b.publishedAt === null || a.publishedAt === null || b.abstract === null || a.abstract === null) {
                    return 0;
                }
                return b.publishedAt.localeCompare(a.publishedAt);
            });

            setFeed(sourceNews);
        } catch (e) {
            if(e.message.length < 150) {
                toast.error(e.message);
                throw e.message;
            }
        }
    };

    const toTop = (e) => {
        if (e.nativeEvent.target.tagName === 'I') {
            return (e.nativeEvent.target.parentElement.parentElement.scrollTop = 0);
        }
        e.nativeEvent.target.parentElement.scrollTop = 0;
    };

    const handleCheckScroll = (e) => {
        const scrollCoordinates = e.nativeEvent.target.scrollTop;
        if (scrollCoordinates > 300) {
            setMode(true);
        } else {
            setMode(false);
        }
    };

    const convertDateString = (date) => {
        return moment(date).format(`MMMM DD, YYYY ${!date.includes('00:00:00.000000') ? 'hh:mm A' : ''}`);
    };
    const createPagination = () => {
        //TODO: need to move pages from this func to component scope-> didmount didupdate
        const pages = Math.ceil(feedSource.length / ItemsOnPageAfterPagination);
        const array = [];

        for (let i = 1; i <= pages; i++) {
            if(pages > paginationButtonsCount) {
                if (activePage <= paginationButtonsBoundary + 1 && i <= paginationButtonsCount) {
                    //active is in []
                    //to make items like [1] 2 3 4 5
                    array.push(i);
                } else if (activePage >= pages - paginationButtonsBoundary && i > pages - paginationButtonsCount) {
                    //to make items like 7 8 9 10 [11]
                    array.push(i);
                } else if (i >= activePage - paginationButtonsBoundary && i <= activePage + paginationButtonsBoundary) {
                    //to make items like 4 5 [6] 7 8
                    array.push(i);
                }
            } else {
                array.push(i);
            }
        }
        return array.map((item) => (
            <li 
                key={item} 
                style={{ cursor: 'pointer' }} 
                onClick={() => changePagination(item)} 
                className={`page-item ${item === activePage && 'active'}`}
            >
                <div className="page-link">{item}</div>
            </li>
        ));
    };

    const handlePaginationChange = (pageNumber) => {
        //TODO: need to move pages from this func to component scope-> didmount didupdate
        const pages = Math.ceil(feedSource.length / ItemsOnPageAfterPagination);
        if (pageNumber > pages || pageNumber < 1) {
            return false;
        } else {
            changePagination(pageNumber);
        }
    };

    const getFilteredList = (list) => {
        const maxCounterOnPage = activePage * ItemsOnPageAfterPagination;
        // authorScreenName: "elonmusk"
        // authorUrl: null
        // createdAt: "2020-11-27 13:34:28"
        // influence: null
        // publishedAt: "2020-11-27 13:34:01"
        // sentiment: 0
        // url: ""
        return list.map((news, index) => (index >= maxCounterOnPage - ItemsOnPageAfterPagination && index < maxCounterOnPage) && (
                <div className="news" key={index} style={{ marginBottom: '12px' }}>
                    <a className="news_link" target="blank" href={news.url}>
                        {news.title && textTruncateByLength(news.title, 140)}
                    </a>
                    <br />
                    {news.domain &&
                        <span style={{ color: '#869fac', fontSize: '.775rem' }}>
                            {news.domain + ' • '}
                        </span>
                    }
                    {news.publishedAt && (
                        <span style={{ color: '#869fac', fontSize: '.775rem' }}>
                            {convertDateString(news.publishedAt) + '  '}
                        </span>
                    )}
                    {news.authorScreenName && (
                        <a 
                            target="_blank"
                            rel="noopener noreferrer"
                            href={news.authorUrl} 
                            style={{ color: '#869fac', fontSize: '.775rem', textDecoration: 'underline' }}
                        >
                            {news.authorScreenName}
                        </a>
                    )}
                    {news.influence && (
                        <span style={{ color: '#869fac', fontSize: '.775rem' }}>
                            &nbsp;{`(${numberWithCommas(news.influence)} ${getInfluenceName(source.type)})`}
                        </span>
                    )}
                    {news.abstract && (
                        <React.Fragment>
                            <br />
                            <span>{news.abstract && textTruncateByLength(news.abstract, 300)}</span>
                        </React.Fragment>
                    )}
                </div>
            )
        )
    }
    
    return (
        <Modal isOpen={isOpen}>
            <ModalHeader toggle={toggle}>
                <div>
                    <h3>Newsfeed Preview:</h3>
                    <h5>{source.attachedName}</h5>
                </div>
            </ModalHeader>
            <ModalBody>
                <div className="modal-wrapper_container ml-0" onScroll={(e) => handleCheckScroll(e)}>
                    {!feedSource ? (
                        <i className="fa fa-spinner fa-spin" />
                    ) : feedSource.length ? (
                        getFilteredList(feedSource)
                    ) : (
                        <div style={{ fontWeight: '700' }}>This Newsfeed is not available yet. Please check again later for updated content.</div>
                    )}
                    {showBtn && (
                        <Button onClick={(e) => toTop(e)} style={{ color: 'white', right: '40px', bottom: '80px' }} className="btnBackToTop">
                            <i className="fas fa-arrow-up" />
                        </Button>
                    )}
                </div>
                {feedSource && feedSource.length > 0 && createPagination().length > 1 && (
                    <nav 
                        className="d-flex flex-column align-items-center" 
                        style={{ display: 'flex', justifyContent: 'center', padding: '10px 0', borderTop: '1px solid #c8ced3' }} 
                        aria-label="Page navigation"
                    >
                        <ul className="pagination" style={{ marginBottom: '0' }}>
                            <li className="page-item">
                                <div
                                    className="page-link"
                                    style={{
                                        color: '#314784',
                                        cursor: 'pointer',
                                    }}
                                    onClick={() => handlePaginationChange(1)}
                                >
                                    <i className="fas fa-angle-double-left" />
                                </div>
                            </li>
                            <li className="page-item">
                                <div
                                    className="page-link"
                                    style={{
                                        color: '#314784',
                                        cursor: 'pointer',
                                    }}
                                    onClick={() => handlePaginationChange(activePage - 1)}
                                >
                                    <i className="fas fa-angle-left" />
                                </div>
                            </li>
                            {createPagination()}
                            <li className="page-item">
                                <div
                                    className="page-link"
                                    style={{
                                        color: '#314784',
                                        cursor: 'pointer',
                                    }}
                                    onClick={() => handlePaginationChange(activePage + 1)}
                                >
                                    <i className="fas fa-angle-right" />
                                </div>
                            </li>
                            <li className="page-item">
                                <div
                                    className="page-link"
                                    style={{ color: '#314784', cursor: 'pointer' }}
                                    onClick={() => handlePaginationChange(Math.ceil(feedSource.length / ItemsOnPageAfterPagination))}
                                >
                                    <i className="fas fa-angle-double-right" />
                                </div>
                            </li>
                        </ul>
                    </nav>
                )}
            </ModalBody>
        </Modal>
    );
};

export default FeedPreviewModal;
